var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUOttaHackLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 236.917,
    height: 230.814,
    viewBox: "0 0 236.917 230.814",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "LOGO_LATEST_VERSION_",
    "data-name": "LOGO LATEST VERSION ",
    transform: "translate(3375 -2135.851)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_23",
    "data-name": "Group 23",
    transform: "translate(-9023.995 -4726.771)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_28",
    "data-name": "Line 28",
    y1: 11.035,
    transform: "translate(5765.125 6887.441)",
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42",
    "data-name": "Path 42",
    d: "M5764.962,6955.983v33.277a.143.143,0,0,0,.069.122l29.374,17.6a.143.143,0,0,0,.216-.122v-35.228a.143.143,0,0,0-.075-.126l-29.375-15.653A.142.142,0,0,0,5764.962,6955.983Z",
    transform: "translate(-0.037 -0.075)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43",
    "data-name": "Path 43",
    d: "M5771.354,6966.817v19.127l16.885,10.12v-20.248Z",
    transform: "translate(-0.042 -0.084)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44",
    "data-name": "Path 44",
    d: "M5764.937,6955.875V6989.3a.077.077,0,0,1-.037.066l-29.5,17.682a.078.078,0,0,1-.118-.067V6971.6a.08.08,0,0,1,.041-.069l29.5-15.722A.077.077,0,0,1,5764.937,6955.875Z",
    transform: "translate(-0.012 -0.075)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45",
    "data-name": "Path 45",
    d: "M5758.556,6966.817v19.127l-16.885,10.12v-20.248Z",
    transform: "translate(-0.018 -0.084)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46",
    "data-name": "Path 46",
    d: "M5735.279,6980.314",
    transform: "translate(-0.012 -0.095)",
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47",
    "data-name": "Path 47",
    d: "M5720.438,6998.589",
    transform: "translate(0 -0.11)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48",
    "data-name": "Path 48",
    d: "M5794.646,7003.8v-13.587l7.415-4.479,7.414,12.842V7082.6",
    transform: "translate(-0.062 -0.1)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49",
    "data-name": "Path 49",
    d: "M5735.279,6971.564",
    transform: "translate(-0.012 -0.088)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50",
    "data-name": "Path 50",
    d: "M5735.279,6971.564",
    transform: "translate(-0.012 -0.088)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_29",
    "data-name": "Line 29",
    y1: 40.883,
    transform: "translate(5764.925 6898.476)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51",
    "data-name": "Path 51",
    d: "M5757.542,6959.914v-17.025l7.415-4.78,7.414,4.78v17.025",
    transform: "translate(-0.031 -0.06)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52",
    "data-name": "Path 52",
    d: "M5764.962,6989.369",
    transform: "translate(-0.037 -0.103)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_53",
    "data-name": "Path 53",
    d: "M5735.267,7003.362v-13.146l-7.415-4.479-7.415,12.842v83.895",
    transform: "translate(0 -0.1)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54",
    "data-name": "Path 54",
    d: "M5787.734,6951.521l6.861,4.175v15.8l-22.244-64.776V6895.87l-7.414,2.63-7.415-3.21v11.771l-22.244,64.438v-15.8l6.721-3.667",
    transform: "translate(-0.012 -0.024)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55",
    "data-name": "Path 55",
    d: "M5765.671,7007.158",
    transform: "translate(-0.038 -0.118)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_56",
    "data-name": "Path 56",
    d: "M5810.195,7032.864",
    transform: "translate(-0.075 -0.139)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_30",
    "data-name": "Line 30",
    x2: 14.829,
    y2: 7.996,
    transform: "translate(5794.583 7007.041)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57",
    "data-name": "Path 57",
    d: "M5735.279,7007.158",
    transform: "translate(-0.012 -0.118)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_31",
    "data-name": "Line 31",
    x1: 14.475,
    y2: 8.562,
    transform: "translate(5720.792 7007.041)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_32",
    "data-name": "Line 32",
    y2: 56.304,
    transform: "translate(5741.653 7031.011)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_33",
    "data-name": "Line 33",
    y2: 44.736,
    transform: "translate(5749.379 7044.296)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_34",
    "data-name": "Line 34",
    y2: 23.158,
    transform: "translate(5757.104 7067.013)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_35",
    "data-name": "Line 35",
    y2: 57.303,
    transform: "translate(5788.007 7031.011)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_36",
    "data-name": "Line 36",
    y2: 44.736,
    transform: "translate(5780.281 7044.296)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_37",
    "data-name": "Line 37",
    y2: 23.158,
    transform: "translate(5772.556 7067.013)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_38",
    "data-name": "Line 38",
    y2: 69.251,
    transform: "translate(5764.83 7021.89)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_8",
    "data-name": "Ellipse 8",
    cx: 3.745,
    cy: 3.745,
    r: 3.745,
    transform: "translate(5761.085 7019.168)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_9",
    "data-name": "Ellipse 9",
    cx: 3.745,
    cy: 3.745,
    r: 3.745,
    transform: "translate(5768.81 7062.575)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_10",
    "data-name": "Ellipse 10",
    cx: 3.745,
    cy: 3.745,
    r: 3.745,
    transform: "translate(5776.536 7040.053)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_11",
    "data-name": "Ellipse 11",
    cx: 3.745,
    cy: 3.745,
    r: 3.745,
    transform: "translate(5784.261 7026.337)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_12",
    "data-name": "Ellipse 12",
    cx: 3.745,
    cy: 3.745,
    r: 3.745,
    transform: "translate(5753.359 7062.575)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_13",
    "data-name": "Ellipse 13",
    cx: 3.745,
    cy: 3.745,
    r: 3.745,
    transform: "translate(5745.633 7040.053)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_14",
    "data-name": "Ellipse 14",
    cx: 3.745,
    cy: 3.745,
    r: 3.745,
    transform: "translate(5737.908 7026.337)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_58",
    "data-name": "Path 58",
    d: "M5735.279,7087.6v-62.812l29.658-17.592,29.658,17.592V7087.6",
    transform: "translate(-0.012 -0.118)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_59",
    "data-name": "Path 59",
    d: "M5764.962,6879.263",
    transform: "translate(-0.037 -0.011)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_60",
    "data-name": "Path 60",
    d: "M5765.162,6902.384v-36.425l12.831,11.386v11.767l-12.831-11.434",
    transform: "translate(-0.037)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("g", {
    id: "Clock_Hands_Right",
    "data-name": "Clock Hands Right",
    transform: "translate(0 291.813)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5",
    "data-name": "Rectangle 5",
    width: 4.731,
    height: 1.206,
    rx: 0.406,
    transform: "translate(5779.2 6691.263) rotate(-90)",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_122",
    "data-name": "Path 122",
    d: "M.485.7,1.84.487,3.521.221c.187,0,.4.354.4.579h0a.377.377,0,0,1-.338.406L.054,1.812c-.187,0-.062-.788-.062-1.013L.077.7C.077.472.3.7.485.7Z",
    transform: "translate(5780.583 6689.829) rotate(45)",
    stroke: "#000",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clock_Hands_Left",
    "data-name": "Clock Hands Left",
    transform: "translate(0 291.813)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1108",
    "data-name": "Rectangle 1108",
    width: 4.731,
    height: 1.206,
    rx: 0.406,
    transform: "translate(5748.519 6691.262) rotate(-90)",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_145",
    "data-name": "Path 145",
    d: "M.309,0H3.6A.378.378,0,0,1,3.94.406V.8a.378.378,0,0,1-.341.406H.309C.12,1.206-.2.738-.2.514L-.032.406A.378.378,0,0,1,.309,0Z",
    transform: "matrix(0.996, -0.087, 0.087, 0.996, 5748.713, 6690.502)",
    stroke: "#000",
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Ring",
    d: "M5854.217,6918.284a116.455,116.455,0,1,1-133.877-2.57",
    transform: "translate(-9041.995 -4764.077)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ring-2",
    "data-name": "Ring",
    d: "M5854.217,6918.284a116.455,116.455,0,1,1-133.877-2.57",
    transform: "translate(-9041.995 -4764.077)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUOttaHackLogo);
export default __webpack_public_path__ + "static/media/uOttaHack-Logo.e7418fd8edc5072fb17365a0a73459a9.svg";
export { ForwardRef as ReactComponent };